import React from 'react';
import { LocationFill } from 'sushiweb/Icons';
import { CopyText } from '../../../../UiKit';
import { grey } from 'sushiweb/tokens/color';

export const UserCity = ({ city = '' }) => {
  return (
    <div>
      <span className='iconMarginR'>
        <LocationFill size={14} color={grey.z500} />
      </span>
      <CopyText type='text' title={city} masking={false} />
    </div>
  );
};
